import React from 'react';
import FeatureUnavailable from '../components/FeatureUnavailable';
import UpgradeRequired from '../components/UpgradeRequired';
import { AppFeatures, Features, canIUse } from '../helpers/PermissionUtility';

export type FeatureFlaggedProps = {
  children: React.ReactElement;
  feature: AppFeatures | Features;
  upgradeRequired?: boolean;
};

/**
 * A component that renders the child component or a `<FeatureUnavailable />` / `<UpgradeRequired />` component if the feature flag
 * given is falsy.
 */
export default function FeatureFlagged({ children, feature, upgradeRequired }: FeatureFlaggedProps) {
  if (!canIUse(feature)) {
    return !!upgradeRequired ? <UpgradeRequired /> : <FeatureUnavailable />;
  }

  return children;
}
